<template>
  <div class="cart-list__el-quantity">
    <div class="quantity">
      <button class="quantity__link quantity__link--minus" @click="quantityMinus()"></button>
      <input class="quantity__control" type="text" v-model="quantity" :min="minQuantity" :max="maxQuantity" :step="stepQuantity"
             @change="quantityChange" @input="quantityInput">
      <button class="quantity__link quantity__link--plus" @click="quantityPlus()"></button>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AddToCartBasket",
  props: {
    productId: Number,
    curQuantity: Number,
    minQuantity: Number,
    maxQuantity: Number,
    stepQuantity: Number,
  },
  data() {
    return {
      quantity: this.curQuantity,
    };
  },
  computed: {
    ...mapGetters('moduleCart', {
      productInCart: 'productInCart',
      cartItemByProductId: 'cartItemByProductId',
    })
  },
  mounted() {
    setTimeout(() => {
      if (this.productInCart(this.productId)) {
        let cartItem = this.cartItemByProductId(this.productId);
        this.quantity = cartItem.quantity;
      }
    }, 500);
  },
  methods: {
    ...mapActions('moduleCart', {
      // addToCart: 'add',
      setQuantity: 'quantity',
    }),
    quantityChange(event) {
      if (parseInt(event.target.value) > this.maxQuantity)
        this.quantity = this.maxQuantity;
      else if (event.target.value === '' || parseInt(event.target.value) < this.minQuantity)
        this.quantity = this.minQuantity;
      else if (event.target.value !== '')
        this.quantity = Number(event.target.value);

      this.quantityUpdate();
    },
    quantityInput(event) {
      if (event.target.value !== '' && !Number(event.target.value))
        this.quantity = this.minQuantity;

      this.quantityUpdate();
    },
    quantityPlus() {
      let tempQuantity;

      if (this.quantity % this.stepQuantity === 0) {
        tempQuantity = this.stepQuantity * (this.quantity/this.stepQuantity + 1);
      } else {
        tempQuantity = this.stepQuantity * Math.ceil(this.quantity/this.stepQuantity);
      }

      if (tempQuantity < this.maxQuantity) {
        this.quantity = tempQuantity;
        this.quantityUpdate();
      } else {
        this.quantity = this.maxQuantity;
        this.quantityUpdate();
      }
    },
    quantityMinus() {
      let tempQuantity;

      if (this.quantity % this.stepQuantity === 0) {
        tempQuantity = this.stepQuantity * (this.quantity/this.stepQuantity - 1);
      } else {
        tempQuantity = this.stepQuantity * Math.floor(this.quantity/this.stepQuantity);
      }

      if (tempQuantity > this.minQuantity) {
        this.quantity = tempQuantity;
        this.quantityUpdate();
      } else {
        this.quantity = this.minQuantity;
        this.quantityUpdate();
      }
    },
    quantityUpdate() {
      if (this.productInCart(this.productId)) {
        let cartItem = this.cartItemByProductId(this.productId);
        let cartId = cartItem.id;
        let quantity = this.quantity;
        this.setQuantity({cartId, quantity});
      }
    },
  }
}
</script>